export default __webpack_public_path__ + "static/media/img-0747-romania-full-face.7135b6f4.png";